import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg"
import ShareButtonImg from "@/common/assets/image/moneyFortune/ShareButton.svg"

export default function PanelButton({ content, onClick, copy, setCopy, type }) {
  return (
    <Wrapper onClick={onClick} className={type}>
      {type === "shareButton" ? (
        <>
          <ButtonWrapper>
            <NextImg src={ShareButtonImg} />
          </ButtonWrapper>
          <Alert className={copy === true && "active"}>已複製</Alert>
        </>
      ) : (
        <>
          <Alert className={copy === true && "active"}>已複製</Alert>
          <p>{content}</p>
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  cursor: pointer;
  width: 100%;
  padding: 12px;
  background: linear-gradient(to right, #e20062 50%, #6809fb);
  background-size: 200% 100%;
  background-position: right bottom;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  font-weight: 700;
  color: #ffffff;
  position: relative;
  transition: all 0.3s;
  p {
    font-size: 24px;
    z-index: 3;
    font-weight: 600;
    color: #fff;
    display: flex;
    align-items: center;
    @media (max-width: 1280px) {
      font-size: 16px;
    }
  }
  &:hover {
    background-position: left bottom;
    p {
      text-shadow: 0px 0px 5px #fff;
    }
  }
  &::after {
    content: "";
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    position: absolute;
    border: 2px solid #fff;
    border-radius: 50px;
  }
  &.secondary {
    background: linear-gradient(to right, #6809fb, #0a8686 30%, #9d05b7);
    background-size: 200% 100%;
    &:hover {
      background-position: right;
    }
  }
  &.disabled {
    opacity: 0.3;
    cursor: default;
  }
  &.simple {
    background: rgba(0, 0, 0, 0);
    color: #00fff0;
    text-decoration: underline;
    /* padding: 0; */
  }
  &.shareButton {
    background: rgba(0, 0, 0, 0);
    color: #00fff0;
    text-decoration: underline;
    padding: 0;
  }
`
const Alert = styled.div`
  position: absolute;
  top: -60px;
  border-radius: 8px;
  padding: 8px 30px;
  background-color: #fff;
  color: #000;
  display: none;
  &:before {
    content: "";
    background-color: #fff;
    position: absolute;
    transition: all 0.3s;
    width: 30px;
    height: 16px;
    bottom: -15px;
    left: 50%;
    transform: translate(-50%, 0);
    clip-path: polygon(0% 0%, 100% 0, 50% 100%);
  }
  &.active {
    display: block;
  }
`

const ButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 31%;
`
